// extracted by mini-css-extract-plugin
module.exports = {"footerMenu":"LoginFooter_footerMenu__fFSOs","footerMenuItem":"LoginFooter_footerMenuItem__tEPqg","footerMenuLink":"LoginFooter_footerMenuLink__3ag-Y"};